module.exports = __webpack_public_path__ + "media/images/orange-icon-location-32e55d836c08469f9bb5d0225d12354e.png";